<template>
	<div style="width: 100%;height: 100%;background: rgba(0,0,0,0.6);" v-loading="getLoading" element-loading-background="rgba(0,0,0,0.6)">
	<div class="popupBox">
		<!-- 安卓2是横屏，ios1是横屏 -->
		<div class="popupCon rewardGift" :class="{'lans':(!isios && osType == 2) || (isios && osType == 1)}">
			<div class="conBox">
				<div class="menus" :class="{'special':isSpecial == 1 || iaaGmCard == 0}">
					<ul v-if="isSpecial == 1">
						<li class="item280"></li>
					</ul>
					<ul v-else>
						<li class="item28" :class="{'active':activeMenu == 28}" @click="handleChangeMenu(28)"></li>
						<li class="item29" :class="{'active':activeMenu == 29}" @click="handleChangeMenu(29)" v-if="iaaGmCard == 1"></li>
					</ul>
				</div>
				<!-- 无限福利部分 -->
				<div class="subConBox" :class="{'lans':(!isios && osType == 2) || (isios && osType == 1)}" v-if="activeMenu == 28">
					<div class="subTitle" :class="{'sfont':(!isios && osType == 2) || (isios && osType == 1)}" v-if="isSpecial == 1">免费抽取极品道具</div>
					<div class="subTitle" :class="{'sfont':(!isios && osType == 2) || (isios && osType == 1)}" v-else>观看视频抽极品</div>
					<div class="tipsBox">* 奖励通过邮件领取</div>
					<div class="rulesBox" @click="showRewardRules = true">
						<img src="/iaa/popupRuleIcon.png" />
						<span>概率说明</span>
					</div>
					
					<div class="reward6List" :class="{'active':!clickFlag}" v-if="rewardProps.length == 6">
						<img src="/iaa/gmrewards_lconbg22.png" style="display: none;" />
						<template v-for="ii in 23" :key="ii">
							<img :src="`/iaa/bk/bk_0000${ii}.png`" style="display: none;" />
						</template>
						<ul>
							<li v-for="(item,index) in rewardProps" :key="index" :class="{'active':index == prizeIndex}" @click="$toast(formatShowDesc(item))">
								<div class="giftItem">
									<img v-if="item.icon" :src="item.icon" />
									<img v-else src="/iaa/gmrewards_key.png" />
									<span>{{ item.amount }}</span>
								</div>
								<p>{{ item.introduction || item.name }}</p>
							</li>
						</ul>
					</div>
					<div class="rewardsList" :class="{'active':!clickFlag}" v-else>
						<img src="/iaa/gmrewards_lconbg12.png" style="display: none;" />
						<ul>
							<template v-for="(item,index) in rewardProps" :key="index">
							<li :class="{'active':index == prizeIndex}" @click="$toast(formatShowDesc(item))" v-if="index < 3">
								<img v-if="item.icon" :src="item.icon" />
								<img v-else src="/iaa/gmrewards_key.png" />
								<span>{{ item.amount }}</span>
							</li>
							</template>
						</ul>
						<div class="dess">
							<template v-for="(item,index) in rewardProps" :key="index">
							<p v-if="index < 3">{{ item.introduction || item.name }}</p>
							</template>
						</div>
					</div>
					
					<div class="btns">
						<div class="items">
							<p><i class="key"></i><span>{{ rewardInfos.turntablePropNum || 0 }}/1</span></p>
							<div class="btnDraw" @click="handleDraw(1)">抽1次</div>
						</div>
						<div class="items">
							<p><i class="key"></i><span>{{ rewardInfos.turntablePropNum || 0 }}/5</span></p>
							<div class="btnDraw bg10" @click="handleDraw(5)">抽5次</div>
						</div>
					</div>
					<div class="btns">
						<div class="items vv">
							<div class="ads" v-if="isSpecial != 1" @click="showAdRules = true"><img src="/iaa/popupIcon.png"><span>{{ rewardInfos.cardNums || 0 }}/1</span></div>
							<p class="nums" v-if="Number(rewardInfos.totalNums) !== Number(rewardInfos.receiveNums)">今日可领取次数:{{ Number(rewardInfos.totalNums) - Number(rewardInfos.receiveNums) || 0 }}</p>
							<p class="nums" v-else>明日再来</p>
							<div class="btnDraw videos" :class="{'disabled':getKeyLoading == true}" @click="handleAdKeys">
								<i class="video" v-if="isSpecial != 1"></i>获取钥匙
							</div>
							<p class="timer" v-if="Number(rewardInfos.coolDownTimer) > 0">
							<!-- <p class="timer"> -->
								<el-countdown title="" :value="cDownTime" />
							</p>
						</div>
						
					</div>
				</div>
				<!-- 福利特权部分 -->
				<div class="subConBox" :class="{'lans':(!isios && osType == 2) || (isios && osType == 1)}" v-if="activeMenu == 29">
					<div class="subTitle sfont tindent">激活特权可获得海量奖励还可免看广告直接抽奖！</div>
					<div class="lineItems" v-for="(e,index) in giftList" :key="index">
						<p class="titles">{{ e.title }}</p>
						<div class="lists">
							<ul>
								<li v-for="(i,j) in formatList(e.item)" :key="j">
									<el-tooltip
										effect="dark"
										placement="top"
										trigger="click"
										:auto-close="2000"
										:content="formatShowDesc(i)"
									  >
										<img :src="i.icon" />
									  </el-tooltip>
									<span>{{ i.amount }}</span>
								</li>
							</ul>
						</div>
					</div>
					<div class="lineItems">
						<p class="titles">每日领取</p>
						<div class="lists">
							<ul>
								<li>
									<el-tooltip
										effect="dark"
										placement="top"
										trigger="click"
										:auto-close="2000"
										:content="`免广告卡`"
									  >
										<img src="/iaa/popupIcon.png" />
									  </el-tooltip>
									<span>{{ activeGift.cardNums }}</span>
								</li>
							</ul>
						</div>
					</div>
					
					<div class="btnBox" style="">
						<a class="purchaseAdsbtn" 
							:class="{'disabled':giftInfo.isBuy == 1}"
							@click="handlePay()"
						>
						<template v-if="giftInfo.isBuy == 1">已购买</template>
						<template v-else>{{ activeGift.money || 0}}</template>
						</a>
						<a class="purchaseAdsbtn"
							:class="{'active':giftInfo.isGet == 0,'disabled':giftInfo.isGet == 1 }"
							@click="handleFreeAdCard()"
						>
						<template v-if="giftInfo.isGet == 1">已领取</template>
						<template v-else>领取</template>
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="closeBtn" :class="{'lans':(!isios && osType == 2) || (isios && osType == 1)}" @click="handleClose"></div>
		
		<Addialog :showVisible="showAdRules" @cancel="cancel">
			<div class="rulesPop" v-html="rewardInfos.describe"></div>
		</Addialog>
		
		<!-- <Addialog :showVisible="showAdReward" @cancel="cancel">
			<div class="rewardPop">
				<div class="props" :style="{ justifyContent:rewardsList.length>4?'flex-start':'center'}">
					<div class="items" v-for="(item,index) in rewardsList" :key="index">
						<img :src="item.icon" />
						<span class="nums">{{ item.amount }}</span>
					</div>
				</div>
				<p>恭喜获得</p>
			</div>
		</Addialog> -->
		<AdRewards :showVisible="showAdReward" :isAds="true" @cancel="cancel">
			<div class="adrewardPop">
				<div class="props" :style="{ justifyContent:rewardsList.length>4?'flex-start':'center'}">
					<div class="itemsbg" v-for="(item,index) in rewardsList" :key="index">
						<div class="items">
							<img :src="item.icon" />
							<span class="nums">{{ item.amount }}</span>
						</div>
						<p>{{ item.introduction || item.name }}</p>
					</div>
					
				</div>
			</div>
		</AdRewards>
		
		<Addialog :showVisible="showRewardRules" @cancel="cancel">
			<div class="rulesPop" v-html="formatBr(rewardInfos.activeRule)"></div>
		</Addialog>
		
	</div>
</div>
</template>

<script setup>
	import { getCurrentInstance,onMounted,onBeforeMount,ref,watch,computed, reactive,inject, onUnmounted } from 'vue'
	import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
	import { useRoute,useRouter } from 'vue-router'
	import useIaaStore from '@/store/modules/iaaParams'
	import iaaSdk from '@/utils/iaa_sdk'
	import Addialog from '@/views/gmtools/addialog'
	import AdRewards from '@/views/gmtools/adsrewards'
	// import Addemo from '@/views/iaa/addemo'
	
	const { proxy } = getCurrentInstance();
	const router = useRouter();
	const activeMenu = ref(28)
	const infos = ref({})
	const rewardInfos = ref({})
	const giftInfo = ref({})
	const rewardProps = ref([])
	const giftList = ref([])
	const keyList = ref([])
	const cDownTimer = ref(Date.now())
	const cDownTime = ref(Date.now())
	const pTimer = ref(null)
	const cTimer = ref(null)
	const cTimeNum = ref(0)
	const loading = ref(false)
	const getLoading = ref(false)
	const drawLoading = ref(false)
	const getKeyLoading = ref(false)
	const errMsg = ref('')
	const isSpecial = ref(0)//不看广告版
	const iaaGmCard = ref(0)//福利特权1打开
	const showAdRules = ref(false)
	const showAdReward = ref(false)
	const showRewardRules = ref(false)
	const prizeIndex = ref(0)
	const startIndex = ref(0)//初始位置
	const clickFlag = ref(true)//是否可以抽奖
	const rewardsList = ref([])
	const activeGift = ref({})
	const reload = inject('reload')
	const secretParams = computed(() => {
		return useIaaStore().secretParams
	})
	const isRefresh = computed(() => {
		return useIaaStore().isRefresh
	})
	const isAdSuccess = computed(() => {
		return useIaaStore().isAdSuccess
	})
	const osType = computed(() => {//1是竖屏
		return useIaaStore().ostype
	})
	const isOpenPlat = computed(() => {
		return iaaSdk.sdkGmOpenPlat() || false
	})
	const isios = ref(false)
	const queryParams = ref({})
	// 2496专属：不走本页逻辑，直接跳 /iaasdk 加载专属图
	const go2496 = () => {
		let gameInfos = iaaSdk.sdkGetInfos() || {}
		if(gameInfos.gameId == '2496'){
			router.replace({ name: 'Iaasdk', query: router.currentRoute.value.query })
			return true
		}
		return false
	}
	onMounted(() => {
		device()
		document.addEventListener('visibilitychange',handleVisibilityChange)
		queryParams.value = router.currentRoute.value.query;
		if(queryParams.value && queryParams.value.isTest){
			useIaaStore().setIsTest(queryParams.value.isTest)
		}else{
			useIaaStore().setIsTest(0)
		}
		if(queryParams.value && queryParams.value.ostype){
			useIaaStore().setOstype(queryParams.value.ostype)
		}
		if(secretParams.value){
			console.log('加载页面有加密串======')
			if(go2496()) return
			getRewardInfo()
		}else{
			console.log('加载初始化======')
			init()
		}
		// console.log(isOpenPlat.value)
	})
	onUnmounted(() => {
		document.removeEventListener('visibilitychange',handleVisibilityChange)
	})
	const handleVisibilityChange = () => {
		if(document.visibilityState === 'visible'){
			console.log('可见')
			init()
		}else{
			getKeyLoading.value = false
			if(cTimer.value){
				clearInterval(cTimer.value)
				cTimer.value = null
			}
			console.log('不可见')
		}
	}
	const device = () => {
		var u = navigator.userAgent;
		var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
		// var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
		if(isIos){
			isios.value = true
		}else{
			isios.value = false
		}
	}
	const formatBr = (str) => {
		if(str != null){
		  str = str.replace(/\n/g,'<br/>');
		}
		return str;
	}
	// const formatStatus = () => {
	// 	let status = 0
	// 	keyList.value.forEach((item,i) => {
	// 		if(item.isGet == 1){
	// 			status++
	// 		}
	// 	})
	// 	return status
	// }
	const init = () => {
		console.log('初始化拿加密串======')
		if(secretParams.value){
			getRewardInfo()
		}else{
			iaaSdk.sdkPostMsg({ action: 'webDidLoad' })
		}
	}
	
	const ctime = () => {
		getKeyLoading.value = true
		cTimer.value = setInterval(() => {
			cTimeNum.value --
			// console.log(cTimeNum.value)
			if(cTimeNum.value < 0){
				clearInterval(cTimer.value)
				cTimer.value = null
				if(cTimeNum.value == -1){
					getKeyLoading.value = false
					getRewardInfo()
				}
			}
		},1000)
	}
	const formatList = (str) => {
		let arr = []
		if(str){
			arr = JSON.parse(str)
		}
		// console.log(arr)
		return arr
	}
	const formatShowDesc = (row) => {
		let str = row.name
		if(row.desc){
			str += ':' + row.desc
		}
		return str
	}
	const handleChangeMenu = (val) => {
		activeMenu.value = val
		// useUserStore().setSubMenuid(val)
		if(val == 28){
			getRewardInfo()
		}else{
			getWelfareInfo()
		}
	}
	const getSpecial = () => {
		iaaSdk.sdkGmSpecialState((res) => {
			isSpecial.value = res.data.specialStatus || 0//1免广告版0正常
		},(err) => {
			console.log(err)
		})
	}
	const getWelfareInfo = () => {
		getLoading.value = true
		iaaSdk.sdkGmWelfareInfo((data) => {
			giftInfo.value = Object.assign({},data)
			giftList.value = data.gmToolConfigList || []
			if(giftList.value.length > 0){
				activeGift.value = giftList.value[0]
			}
			
			getLoading.value = false
		},(err) => {
			errMsg.value = err.msg
			getLoading.value = false
		})
	}
	const getRewardInfo = () => {
		let infos = iaaSdk.sdkGetInfos() || {}
		// if(infos && infos.gameId){
		// 	console.log(infos.gameId)
		// 	if(infos.gameId == '2266' && infos.chanleNo != '40048'){//2266
		// 		isSpecial.value = true
		// 	}else{
		// 		isSpecial.value = false
		// 	}
		// }
		getSpecial()
		if(cTimer.value){
			clearInterval(cTimer.value)
			cTimer.value = null
		}
		getLoading.value = true
		iaaSdk.sdkGmDialogRewardInfo((data) => {
			if(data && data.luckyIaa == 1){//0就是iaa  1就是幸运礼包的
				router.push({ name: 'SuperLuckysdk', query: queryParams.value });
			}
			rewardInfos.value = Object.assign({},data)
			rewardProps.value = JSON.parse(data.turntableItems)
			iaaGmCard.value = data.iaaGmCard
			if(Number(data.coolDownTimer) > 0){
				cDownTime.value = Date.now() + 1000 * Number(data.coolDownTimer)
				cTimeNum.value = Number(data.coolDownTimer)
				ctime()
			}else{
				cDownTime.value = Date.now()
			}
			getLoading.value = false
			if(isAdSuccess.value == 2 && data.turntablePropNum > 0){
				console.log('自动抽奖2====')
				handleDraw(1)
				useIaaStore().setAdSuccess(0)
			}
		},(err) => {
			errMsg.value = err.msg
			getLoading.value = false
		})
		const screenWidth = window.screen.width;
		const screenHeight = window.screen.height;
		console.log('屏幕宽===='+screenWidth)
		console.log('屏幕高===='+screenHeight)
	}
	
	// 看广告获取钥匙
	const handleAdKeys = () => {
		if(getKeyLoading.value){
			return false
		}
		getKeyLoading.value = true
		if(isSpecial.value == 1){
			getSpecialOrder()
		}else{
			iaaSdk.sdkGmVideoAdKeys((data) => {
				useIaaStore().setAdSuccess(1)
				iaaSdk.sdkPostMsg({ action: 'playAdsZp', data })
				getKeyLoading.value = false
			},(res)=>{
				getKeyLoading.value = false
				if(res.code == 202){//使用免广告卡了
					getRewardInfo()
				}
			})
		}
	}
	const getSpecialOrder = () => {
		iaaSdk.sdkGmSpecialOrder((data) => {
			getKeyLoading.value = false
		},(res)=>{
			getKeyLoading.value = false
			if(res.code == 202){//使用免广告卡了
				getRewardInfo()
			}
		})
	}
	const handlePay = () => {
		if(giftInfo.value.isBuy == 1){//buy 1买了 0没买
			proxy.$toast('已经买过了')
			return false
		}
		let args = {
			menuId: 29,//menuid.value,
			goodId: activeGift.value.id,
			goodName: activeGift.value.title,
			money: 10,//activeGift.value.money,
			remark: activeGift.value.id
		}
		iaaSdk.sdkPostMsg({
			action: 'pay_action', data: JSON.stringify(args)
		})
	}
	// 领广告卡
	const handleFreeAdCard = () => {
		if(giftInfo.value.isBuy == 0){//isBuy 1买了 0没买
			proxy.$toast('购买后才能领取哦～')
			return false
		}
		if(giftInfo.value.isGet == 1){//isGet  1领取 0没领取
			proxy.$toast('已经领取过啦，请明天再来～')
			return false
		}
		iaaSdk.sdkGmWelfareProp((data) => {
			getRewardInfo()
		},(err) => {
			console.log(err)
		})
	}
	// 抽奖
	const handleDraw = (num) => {
		if(rewardInfos.value.turntablePropNum < num){
			ElMessage({
			    message: '您的钥匙还不够抽奖哦，快去看广告获取钥匙吧～',
			    type: 'error',
				plain: true
			})
			return false
		}
		// if(rewardInfos.value.turntableNum && Number(rewardInfos.value.turntableNum) + num > 20){//每天只能抽取20次
		// 	ElMessage({
		// 	    message: '今日抽取次数已达上限～',
		// 	    type: 'error',
		// 		plain: true
		// 	})
		// 	return false
		// }
		if(drawLoading.value){
			return false
		}
		drawLoading.value = true
		iaaSdk.sdkGmRewardGetProp(num,(data) => {
			playStart(data)
		},() => {
			drawLoading.value = false
		})
	}
	const playStart = (arr) => {
		rewardsList.value = Object.assign([],arr)
		let prize = arr.slice(-1)
		let prizeIndex = ''
		rewardProps.value.forEach((item,index) => {
			if(item.mid == prize[0].mid && item.type == prize[0].type){
				prizeIndex = String(index)
			}
		})
		let prizeItem = Object.assign({},prize[0])
		
		rotate(prizeItem,prizeIndex)
	}
	// 转动
	const rotate = (prize,prizeIndex) => {//目前是只转动转盘
		if (!clickFlag.value) return;
		var type = 0; // 默认为 0  转动
		var duringTime = 0.1; // 默认为 5s
		
		clickFlag.value = false; // 结束前，不允许再次触发
		if (type == 0) {
			 prizeTimer()
			 // 结束后允许再次触发
			 setTimeout(()=>{
				 clickFlag.value = true;
				 gameOver()
			 }, duringTime * 1000+200)
		}
	}
	const prizeTimer = () => {
		pTimer.value = setInterval(() => {
			var prizenum = rewardProps.value.length == 6 ? 6 : 3;
			// 转动
			var newIndex = startIndex.value % prizenum;//将要跳转位置
			startIndex.value = newIndex+1;//改变初始位置
			prizeIndex.value = newIndex;//真正控制转动角度
		},200)
	}
	// 游戏结束
	const gameOver = (prize) => {
		//游戏结束,重置初始位置
		clearInterval(pTimer.value)
		pTimer.value = null
		prizeIndex.value = 0
		startIndex.value = 0
		drawLoading.value = false
		// 中奖弹窗提示
		showRewards()
	}
	const showRewards = () => {
		showAdReward.value = true
		getRewardInfo()
		// rewardsList.value = Object.assign([],data)
	}
	const handleClose = () => {
		console.log('关闭弹窗')
		useIaaStore().setAdSuccess(0)
		useIaaStore().setSecretParams('').then(() => {
			iaaSdk.sdkPostMsg({ action: 'close' })
		})
	}
	const cancel = () => {
		showAdRules.value = false
		showAdReward.value = false
		showRewardRules.value = false
		// showRewardGzh.value = false
	}
	watch(secretParams, (newVal,oldVal) => {
		if(newVal){
			console.log('监听到加密串查看详情======')
			if(go2496()) return
			getRewardInfo()
		}
	},{ deep:true })
	watch(isRefresh, (newVal,oldVal) => {
		let nowPageName = router.currentRoute.value.name
		if(newVal && newVal == nowPageName){
			useIaaStore().setRefresh('')
			// reload()
			console.log('刷新======')
			handleChangeMenu(activeMenu.value)
		}
	},{ deep:true })
</script>

<style lang="less" scoped>
	@width: 90vw;@height: calc(@width / 4 * 7);
	@maxWidth: 45rem;
	@primary: #FE551F;
	@white: #FFF;
	@light: #05B700;
	@keyframes blingbling {
		0%,50%,100% {
			background: url('/iaa/gmrewards_lconbg1.png') no-repeat center top;
			background-size: 100%; 
		}
		25%,75% { 
			background: url('/iaa/gmrewards_lconbg12.png') no-repeat center top;
			background-size: 100%;
		}
	}
	@keyframes blingbling6 {
	    0%,50%,100% { 
			background: url('/iaa/gmrewards_lconbg2.png') no-repeat center top;
			background-size: 100%; 
		}
	    25%,75% { 
			background: url('/iaa/gmrewards_lconbg22.png') no-repeat center top;
			background-size: 100%;
		}
	}
	
	.loop(@i) when (@i <= 23) {
		@per: @i*4.3%;
		@{per} { 
		  background: url("/iaa/bk/bk_0000@{i}.png") no-repeat center;
		  background-size: 160%;
		}
		.loop(@i + 1);
	}
	@keyframes drawing {
		.loop(0);
	}
	.subCons(@n){
		.subConBox{
			width: 100%;height: 100%;margin: 0 auto;overflow: hidden;
			padding: calc(2% * @n) 3%;box-sizing: border-box;
			.subTitle{
				width: 100%;color: @primary;font-weight: bolder;height: 11%;
				display: flex;align-items: center;justify-content: center;font-size: calc(1.5rem * @n);
				padding: 0 5%;box-sizing: border-box;
				&.sfont{
					font-size: calc(1.2rem * @n);
				}
				&.tindent{
					text-indent: 2em;margin-bottom: 5%;line-height: calc(1.3rem * @n);font-size: calc(1.1rem * @n);
					padding-top: calc(0.2rem * @n)!important;
				}
			}
			.btnBox{
				width: 80%;margin: 2% auto 0;display: flex;align-items: center;justify-content: space-around;
				.purchaseAdsbtn{
					background: url('/iaa/gmrewards_btnbg1.png') no-repeat center;
					background-size: 100%;color: #fff;display: inline-block;
					width: 42%;height: calc(3rem * @n);text-align: center;line-height: calc(3rem * @n);
					margin-top: 2%;font-size: calc(1.4rem * @n);
					&.active{
						background: url('/iaa/gmrewards_btnbg10.png') no-repeat center;
						background-size: 100%;
					}
					&.disabled{
						filter: grayscale(1);
					}
				}
			}
			.tipsBox{
				position: absolute;left: 6%;top: 13%;font-size: calc(1rem * @n);color: @primary;
				display: flex;align-items: center;justify-content: flex-start;
				margin: 1% auto 0;height: 5%;width: 60%;line-height: calc(1rem * @n);
			}
			.rulesBox{
				display: flex;align-items: center;justify-content: flex-end;
				width: calc(6rem * @n);margin: 1% auto 0;height: 5%;
				position: absolute;right: 8%;top: 13%;
				img{
					width: calc(1.3rem * @n);height: calc(1.3rem * @n);margin-right: calc(0.2rem * @n);
				}
				span{
					font-size: calc(1rem * @n);color: @primary;
				}
			}
			.rewardsList{
				width: 96%;height: 36%;margin: 10% auto 4%;overflow-y: hidden;
				background: url('/iaa/gmrewards_lconbgs.png') no-repeat center;
				background-size: 100%;position: relative;
				&::after{
					content: '';position: absolute;width: 100%;height: 100%;left: 0;top: 0;
					background: url('/iaa/gmrewards_lconbg1.png') no-repeat center top;
					background-size: 100%;z-index: 1;
				}
				&.active{
					&::after{
						content: '';position: absolute;width: 100%;height: 100%;left: 0;top: 0;
						background: url('/iaa/gmrewards_lconbg12.png') no-repeat center top;
						background-size: 100%;
						animation: blingbling 0.2s ease;
						animation-iteration-count: 1;
					}
					
				}
				.dess{
					width: 100%;height: 30%;overflow: hidden;
					display: flex;align-items: flex-start;justify-content: center;
					padding: 0.375rem 0.3125rem;box-sizing: border-box;
					p{
						// display: inline-block;
						width: calc(100% / 3);padding: 0 calc(0.3125rem * @n);box-sizing: border-box;
						color: #fff;font-size: calc(0.75rem * @n);
						display: -webkit-box;
						  -webkit-line-clamp: 2; /* 限制显示的行数为3行 */
						  -webkit-box-orient: vertical;
						  overflow: hidden;
					}
				}
				ul{
					padding: 5% 5% 4%;width: 100%;height: 68%;box-sizing: border-box;
					li{
						float: left;text-align: center;
						width: calc(100% / 3);height: 100%;
						padding: calc(0.6rem * @n) calc(0.5rem * @n);box-sizing: border-box;position: relative;
						background: url('/iaa/gmrewards_iconbg.png') no-repeat center;
						background-size: 84%;z-index: 11;
						img{
							width: 70%;
						}
						span{
							position: absolute;bottom: 4%;right: 15%;font-size: calc(0.75rem * @n);
							color: #6A0000;font-weight: 500;
						}
						&.active{
							background: url('/iaa/gmrewards_iconbgon.png') no-repeat center;
							background-size: 84%;
							
						}
					}
				}
			}
			.reward6List{
				width: 96%;height: 42%;margin: 11% auto 2%;overflow-y: hidden;
				background: url('/iaa/gmrewards_lconbgs2.png') no-repeat center;
				background-size: 100%;position: relative;
				&::before{
					content: '';position: absolute;width: 90%;height: 91%;left: 5%;top: 5%;
					background: url('/iaa/gmrewards_border.png') no-repeat center;
					background-size: 100%;z-index: 1;
				}
				&::after{
					content: '';position: absolute;width: 100%;height: 100%;left: 0;top: 0;
					background: url('/iaa/gmrewards_lconbg2.png') no-repeat center top;
					background-size: 100%;z-index: 1;
				}
				&.active{
					&::after{
						content: '';position: absolute;width: 100%;height: 100%;left: 0;top: 0;
						background: url('/iaa/gmrewards_lconbg22.png') no-repeat center top;
						background-size: 100%;
						animation: blingbling6 0.2s ease;
						animation-iteration-count: 1;
					}
					
				}
				ul{
					padding: 5.5% 5% 3.5%;width: 100%;height: 100%;box-sizing: border-box;
					li{
						float: left;text-align: center;
						width: calc(100% / 3);height: 50%;
						padding: calc(0.25rem * @n) 0 calc(0.375rem * @n);box-sizing: border-box;
						background: url('/iaa/gmrewards_iconbg22.png') no-repeat center bottom;
						background-size: 100%;z-index: 11;
						position: relative;
						.giftItem{
							position: relative;width: 50%;height: 70%;margin: 0 auto;
							background: url('/iaa/gmrewards_sgift.png') no-repeat center;
							background-size: 100%;
							display: flex;align-items: center;justify-content: center;
							img{
								width: 80%;
							}
							span{
								position: absolute;bottom: 4%;right: 10%;font-size: calc(0.6rem * @n);
								color: #6A0000;font-weight: 500;
							}
						}
						&:nth-child(2){
							background: url('/iaa/gmrewards_iconbgon2.png') no-repeat center bottom;
							background-size: 100%;
							
						}
						&:nth-child(5){
							background: url('/iaa/gmrewards_iconbgon3.png') no-repeat center bottom;
							background-size: 100%;
							
						}
						&.active{
							&::after{
								position: absolute;content: '';left: 0;top: 0;width: 100%;height: 96%;
								background: url('/iaa/bk/bk_00000.png') no-repeat center;
								background-size: 160%;
								animation: drawing 1.1s ease;
								animation-iteration-count: infinite;
							}
							
						}
						p{
							font-size: calc(0.6rem * @n);color: #FE602F;
							display: -webkit-box;
							  -webkit-line-clamp: 1; /* 限制显示的行数为3行 */
							  -webkit-box-orient: vertical;
							  overflow: hidden;
						}
					}
				}
			}
			.btns{
				width: 90%;height: calc(11% * @n);margin: 2% auto 0;
				display: flex;align-items: flex-start;justify-content: center;
				.ads{
					display: flex;align-items: center;justify-content: center;
					img{
						width: calc(1.6rem * @n);margin-right: calc(0.5rem * @n);
					}
					span{
						color: @light;font-size: calc(1.2rem * @n);
					}
				}
				.nums{
					margin: 0;font-size: calc(1rem * @n);
				}
				.items{
					width: 50%;height: 100%;
					&.vv{
						width: 65%;margin-top: calc(0.5rem * @n);
					}
					.timer{
						text-align: center;
						/deep/.el-statistic__content{
							color: @light;font-size: calc(1.4rem * @n);
						}
					}
					.btnDraw{
						width: calc(63% * @n);height: calc(54% * @n);color: #fff;margin: 0 auto;
						background: url('/iaa/popupBtn1.png') no-repeat center;
						background-size: 100%;font-size: calc(1.2rem * @n);
						display: flex;align-items: center;justify-content: center;
						&.videos{
							background-size: 120%;border-radius: calc(0.5rem * @n);width: calc(80% * @n);
							box-shadow: inset 0 0 calc(0.5rem * @n) calc(0.2rem * @n) rgba(#FC586C, 0.6);
							&.disabled{
								filter: grayscale(1);
							}
						}
						&.bg10{
							background: url('/iaa/popupBtn10.png') no-repeat center;
							background-size: 100%;
						}
						.video{
							display: inline-block;width: calc(1.6rem * @n);height: calc(1.4rem * @n);
							background: url('/iaa/popupVideo.png') no-repeat center;
							background-size: 100%;margin-right: calc(0.3rem * @n);margin-left: calc(-0.3rem * @n);
						}
					}
					p{
						display: inline-flex;align-items: center;justify-content: center;
						width: 100%;
						.key{
							display: inline-block;width: calc(1.4rem * @n);height: calc(1.4rem * @n);
							background: url('/iaa/popupKey.png') no-repeat center;
							background-size: 100%;margin-right: calc(0.2rem * @n);
						}
						span{
							color: @light;font-size: calc(1.1rem * @n);
						}
					}
				}
			}
			&.lans{
				.btns{
					.items{
						.btnDraw{
							height: calc(55% * @n);
							&.videos{
								width: calc(85% * @n);
							}
						}
					}
				}
			}
		}
	}
	.adrewardPop{
		width: 100%;height: 100%;margin: 0 auto;padding: 2%;box-sizing: border-box;
		display: flex;align-items: center;flex-wrap: wrap;
		.props{
			width: calc(5.6rem * 4);height: 100%;overflow-y: scroll;margin: 0 auto;
			display: flex;align-items: center;justify-content: flex-start;flex-wrap: wrap;
			background: rgba(255,255,255,0.01);
		}
		.itemsbg{
			width: 7.36rem;height: 7.52rem;min-width: 60px;min-height: 62px;
			padding: 0.5rem;box-sizing: border-box;
			background: url('/iaa/rewardsItembg.png') no-repeat center;
			background-size: 100%;
			display: grid;
			p{
				font-size: 1rem;line-height: 1rem;
				display: -webkit-box;
				  -webkit-line-clamp: 2; /* 限制显示的行数为3行 */
				  -webkit-box-orient: vertical;
				  overflow: hidden;
			}
		}
		.items{
			width: 4rem;height: 4rem;padding: 0.8rem;box-sizing: border-box;
			background: url('/iaa/gmrewards_iconbgon.png') no-repeat center;
			background-size: 100%;margin: 0.4rem auto 0;position: relative;
			img{
				width: 100%;
			}
			.nums{
				position: absolute;right: 0.3rem;bottom: 0;
				font-size: 1rem;color: #6A0000;
			}
		}
		p{
			width: 100%;text-align: center;font-size: 1rem;
		}
	}
	.rewardPop{
		width: 100%;height: 100%;margin: 0 auto;padding: 2%;box-sizing: border-box;
		display: flex;align-items: center;flex-wrap: wrap;
		.props{
			width: calc(5.6rem * 4);height: 80%;overflow-y: scroll;margin: 0 auto;
			display: flex;align-items: center;justify-content: flex-start;flex-wrap: wrap;
		}
		.items{
			width: 4.8rem;height: 4.8rem;padding: 0.8rem;box-sizing: border-box;
			background: url('/iaa/popupIconbg.png') no-repeat center;
			background-size: 100%;margin: 0.4rem;position: relative;
			img{
				width: 100%;
			}
			.nums{
				position: absolute;right: 0.3rem;bottom: 0;
				font-size: 1rem;
			}
		}
		p{
			width: 100%;text-align: center;font-size: 1.6rem;
		}
	}
	.rulesPop{
		width: 94%;height: 90%;margin: 3% 3% 4%;overflow-y: scroll;font-size: 1.3rem;
	}
	
	.popupBox{
		width: 100%;height: 100vh;max-width: @maxWidth;margin: 0 auto;position: relative;overflow: hidden;
		
		.closeBtn{
			position: absolute;width: 3rem;height: 3rem;
			right: calc((100% - @width) / 2);top: calc((100vh - @width / 4 * 7) / 2 + @width / 4 * 7 * 0.11);
			background: url('/iaa/popupClose.png') no-repeat center;
			background-size: 100%;
			&.lans{//横屏宽按70vh算
				right: calc((100% - 70vh) / 2);top: calc(30vh / 2 - 3rem);
			}
		}
		.popupCon{
			// width: 32rem;height: 56rem;
			width: @width;height: @height;
			position: absolute;left: 50%;top: 50%;
			transform: translate(-50%,-50%);
			
			&.rewardGift{
				background: url('/iaa/popupBgtabs.png') no-repeat center;
				background-size: 100%;
				.rulesBox{
					display: flex;align-items: center;justify-content: flex-end;
					width: 90%;margin: 7% auto 0;height: 7%;
					img{
						width: 1.8rem;height: 1.8rem;margin-right: 0.5rem;
					}
					span{
						font-size: 1.2rem;
					}
				}
				
				
				
				.lineItems{
					width: 100%;height: 32%;padding: 0;box-sizing: border-box;margin-top: 1%;
					.titles{
						font-size: 1.4rem;font-weight: bold;color: @primary;line-height: 3rem;height: 3rem;
						background: url('/iaa/tagbg.png') no-repeat center;
						background-size: 100%;display: inline-block;width: 38%;padding: 0 2%;box-sizing: border-box;
						white-space: nowrap;overflow: hidden;text-overflow: ellipsis;
					}
					.lists{
						width: 100%;height: calc(100% - 3rem);
						background: url('/iaa/itembg.png') no-repeat center;
						background-size: 95%;padding: 4.2% 5%;box-sizing: border-box;overflow-x: scroll;
						ul{
							display: flex;align-items: center;justify-content: flex-start;height: 100%;
							li{
								background: url('/iaa/gmrewards_iconbg2.png') no-repeat center;
								background-size: 100%;position: relative;
								width: 21%;height: 100%;padding: 0.5rem;box-sizing: border-box;flex-shrink: 0;
								display: flex;align-items: center;
								img{
									width: 100%;
								}
								span{
									position: absolute;right: 0.3rem;bottom: 0.3rem;font-size: 1rem;color: #01025F;
								}
							}
							li + li{
								margin-left: 0.5rem;
							}
						}
					}
				}
				.rules{
					width: 100%;text-align: center;font-size: 0.9rem;
				}
				
			}
			.conBox{
				position: absolute;width: 78%;height: 60%;color: @primary;
				left: 50%;top: 50%;transform: translate(-50%,-50%);padding-right: 1%;box-sizing: border-box;
				.menus{
					position: absolute;top: -11%;left: -5%;width: 80%;height: 12%;
					&.special{
						left: 50%;transform: translate(-50%,0);
						ul{
							justify-content: center;
							li{
								&.item280{
									// background: url('/iaa/title2.png') no-repeat center;
									background: url('/iaa/title28.png') no-repeat center;
									background-size: 100%;
								}
							}
						}
					}
					ul{
						width: 100%;height: 100%;
						display: flex;align-items: center;justify-content: flex-start;
						li{
							width: 50%;height: 100%;
							&.item28{
								background: url('/iaa/title28_active.png') no-repeat center;
								background-size: 100%;
								&.active{
									background: url('/iaa/title28.png') no-repeat center;
									background-size: 100%;
								}
							}
							&.item29{
								background: url('/iaa/title29_active.png') no-repeat center;
								background-size: 100%;
								&.active{
									background: url('/iaa/title29.png') no-repeat center;
									background-size: 100%;
								}
							}
						}
						li + li{
							margin-left: -4%;
						}
					}
				}
				
				.subCons(1.2)
				// .title{
				// 	font-size: 2.2rem;letter-spacing: 0.1rem;height: 8%;
				// 	width: 100%;text-align: center;margin-top: 14%;
				// }
			}
			&.lans{//横屏
				width: 70vh;height: calc(70vh / 4 * 7);
				&.superGift,&.rewardGift{
					background-position: center bottom;
				}
				.conBox{
					top: 56%;
					.subCons(1.1)
					.title{
						font-size: 1.875rem;margin-top: 15%;
					}
					.btns{
						.ads{
							img{
								width: 1.8rem;
							}
						}
					}
				}
				&.rewardGift{
					.rulesBox{
						img{
							width: 1.25rem;height: 1.25rem;
						}
					}
					.btns .items .btnDraw.videos{
						width: 90%;
					}
				}
			}
		}
		
	}
	
	@media all and (orientation : landscape) and (min-width: 600px) and (min-height: 600px){
		@width: 35rem;
		.popupBox .popupCon{
			width: @width !important;height: calc(@width / 4 * 7) !important;
		}
		.popupBox .closeBtn{
			right: calc((100% - @width) / 2) !important;top: calc((100vh - @width / 4 * 7) / 2 + @width / 4 * 7 * 0.11) !important;
		}
	}
	@media all and (orientation : landscape) and (min-width: 600px) and (max-height: 450px){
		@width: 70vh;
		.popupBox .closeBtn{
			right: calc((100% - @width) / 2);top: calc((100vh - @width) / 2 - 3rem);
		}
		.popupBox .popupCon{
			width: @width;height: calc(@width / 4 * 7);
			&.superGift,&.rewardGift{
				background-position: center bottom;
			}
			.conBox{
				.subCons(1.05)
			}
			
		}
	}
	@media all and (orientation : landscape) and (min-width: 600px) and (max-height: 360px){
		@width: 70vh;
		.popupBox .closeBtn{
			right: calc((100% - @width) / 2);top: calc((100vh - @width) / 2 - 3rem);
		}
		.popupBox .popupCon{
			width: @width;height: calc(@width / 4 * 7);
			&.superGift,&.rewardGift{
				background-position: center bottom;
			}
			.conBox{
				.subCons(1)
			}
			
		}
	}
	@media all and (orientation : portrait) and (min-width: 600px) and (min-height: 600px){
		@width: 35rem;
		.popupBox .popupCon{
			width: @width;height: calc(@width / 4 * 7);
			// .sfont{
			// 	font-size: 1.6rem!important;
			// }
			.conBox{
				.subCons(1.2)
			}
		}
		.popupBox .closeBtn{
			right: calc((100% - @width) / 2);top: calc((100vh - @width / 4 * 7) / 2 + @width / 4 * 7 * 0.11);
		}
	}
	@media all and (orientation : portrait) and (max-width: 375px){
		.popupBox .popupCon{
			.conBox{
				.subCons(1.2)
				.title{
					margin-top: 13%;
				}
			}
		}
	}
</style>